// This function will create a list of all anchors and their corresponding line number.

import { MappedAnchorLine } from '../../../types/utils';

// Since the code will be stripped of the anchor points we have to map the line numbers to be correct in the cleaned code.
export const getAnchorsFromCode = (
  code: string,
  anchors: string[],
  file: number,
): MappedAnchorLine[] => {
  const lines: string[] = code.split(/\r?\n/);
  // get the anchor and the corresponding line number in the original code snippet
  const anchorMap = lines.reduce(
    (acc: Array<[string, number]>, line, i): Array<[string, number]> => {
      const anchorIndex = anchors.findIndex(anchor =>
        line.match(`(${anchor})([^a-zA-Z\\S]|$|-->$)`),
      );

      if (anchorIndex === -1) return acc;
      return [...acc, [anchors[anchorIndex], i]];
    },
    [],
  );

  // map the original line number to the cleaned text
  const correctedAnchors = anchorMap.reduce(
    (acc: MappedAnchorLine[], anchor, i): MappedAnchorLine[] => {
      // it is important to know if the anchor is the start or the end of a highlight range
      const anchorIndixesBefore = anchorMap.reduce(
        (ac: number[], [key, line]) => {
          if (key === anchor[0] && line < anchor[1]) return [...ac, line];
          return ac;
        },
        [],
      );

      const end = anchorIndixesBefore.length % 2 === 1;

      // substract all previous line numbers which will be stripped
      // add 1 to shift the index from 0 to 1
      // substract one if the anchor is the end, else it would highlight the next line aswell
      return [
        ...acc,
        {
          highlight: anchor[0],
          lineNumber: anchor[1] - i + 1 - (end ? 1 : 0),
          file,
        },
      ];
    },
    [],
  );

  return correctedAnchors;
};
